var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcXPrimary({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5312 3.52861C3.79155 3.26826 4.21366 3.26826 4.47401 3.52861L8.00261 7.0572L11.5312 3.52861C11.7915 3.26826 12.2137 3.26826 12.474 3.52861C12.7344 3.78896 12.7344 4.21107 12.474 4.47142L8.94541 8.00001L12.474 11.5286C12.7344 11.789 12.7344 12.2111 12.474 12.4714C12.2137 12.7318 11.7915 12.7318 11.5312 12.4714L8.00261 8.94282L4.47401 12.4714C4.21366 12.7318 3.79155 12.7318 3.5312 12.4714C3.27085 12.2111 3.27085 11.789 3.5312 11.5286L7.0598 8.00001L3.5312 4.47141C3.27085 4.21107 3.27085 3.78896 3.5312 3.52861Z",
    fill: "#116584"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcXPrimary);
export default __webpack_public_path__ + "static/media/ic-x-primary.817d6f7965f364c939d3971561ffeed8.svg";
export { ForwardRef as ReactComponent };